import React from 'react';
import { Registration } from 'components/registration/Registration';

export const RegistrationPage: React.FC = () => {
    return <Registration />;
};
